import React from 'react';
import {LoadingContext} from '../../contexts/LoadingContext';
import {CircularProgress, Backdrop} from '@material-ui/core';

export default function Spinner() {
    const {loading} = React.useContext(LoadingContext);

    return <>
        <Backdrop style={{zIndex:1}} open={loading}>
            <CircularProgress className={'center-all'} variant="indeterminate" color="primary"/>
        </Backdrop>
    </>;
}